<div class="justify-content-center additional-info-header m-b-25" translate>dimbo.i18n.sp.header</div>
<div class="straight-line m-b-25"></div>
<div mat-dialog-content>

    <div class="container-box">

        <form>

            
            <div class="row justify-content-center criteria-box">
                <mat-form-field class="mat-input-text mat-custom-cal">
                    <mat-label translate>dimbo.i18n.label.customerLastName</mat-label>
                    <input matInput name="customerLastName" [(ngModel)]="customerLastName" maxlength="500">
                </mat-form-field>
            </div>  
            <br>
            
            <div class="row justify-content-center criteria-box">
                <mat-form-field class="mat-input-text mat-custom-cal">
                    <mat-label translate>dimbo.i18n.label.phoneNumber</mat-label>
                    <input matInput name="phoneNumber" [(ngModel)]="phoneNumber" maxlength="25">
                </mat-form-field>
            </div>  
            <br>

            <div class="row justify-content-center criteria-box">
                <mat-form-field class="mat-input-text mat-custom-cal">
                    <mat-label translate>dimbo.i18n.label.customerEmail</mat-label>
                    <input matInput name="customerEmail" [(ngModel)]="customerEmail">
                </mat-form-field>
            </div>
            <br>
        
            <div class="row justify-content-center criteria-box">
                <mat-form-field class="mat-input-text mat-custom-cal">
                    <mat-label translate>dimbo.i18n.label.registration</mat-label>
                    <input matInput name="registration" [(ngModel)]="registration" [disabled]="isServiceHistory">
                </mat-form-field>
            </div>  
            <br>
        
            <div class="row justify-content-center criteria-box">
                <mat-form-field  class="mat-custom-cal">
                    <input matInput [matDatepicker]="picker" [max]="maxDate" [(ngModel)]="firstRegistrationDate" name="firstRegistrationDate" [placeholder]=regdplaceholder disabled>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker [disabled]="isServiceHistory"></mat-datepicker>
                </mat-form-field>
            </div>
            <br>
            
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field class="m-l-20 p-b-20">
                        <mat-label translate>dimbo.i18n.label.currentMileage</mat-label>
                        <input matInput name="currentMileage" [(ngModel)]="currentMileage" [disabled]="isServiceHistorycm">
                    </mat-form-field>
                </div>
                <div class="col-sm-7 m-t-20">
                    <mat-radio-group class="float-right m-r-10" aria-label="Select an option" name="mileageUnit" [(ngModel)]="mileageUnit" [disabled]="isServiceHistory">
                        <mat-radio-button class="custom-font" value="km"><span translate>dimbo.i18n.km</span></mat-radio-button>
                        <mat-radio-button class="custom-font" value="mi"><span translate>dimbo.i18n.miles</span></mat-radio-button>
                    </mat-radio-group>
                </div>
                
            </div>
            <br>
        
            <!-- <div mat-dialog-actions> -->
            <div class="container m-b-15">    
                <div class="row">

                    <div class="col-sm-6">
                        <input class="float-left dialog-cancel-button dialog-cancel-button-text m-l-5 m-t-10" type="button" (click) = close() [value]="canceltranlation">
                    </div>
                    <div class="col-sm-6">
                        <input class="float-right dialog-button dialog-button-text m-r-25 m-t-10" style="padding-top: 3px;" type="button" (click)="allowAddService()" [value]="oktranlation">
                    </div>
					
                </div>
            </div>

        </form>


    </div>

</div>
